import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ยื่นขอส่งเสริมการลงทุน BOI — Activity List 2566 + Smart Visa","metaTitle":"BOI Application — ที่ปรึกษายื่นขอส่งเสริม BOI ครบวงจร | NYC","metaDesc":"ที่ปรึกษายื่นขอส่งเสริมการลงทุน BOI ทุกหมวด A1-B2 ยกเว้นภาษี 3-13 ปี ถือครองที่ดิน Smart Visa 4 ปี — ค่าดำเน — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"BOI Application — Activity List 2023 + Smart Visa Package","metaTitle":"Thailand BOI Application — End-to-End Advisory | NYC","metaDesc":"Full BOI advisory: activity classification A1-B2, feasibility study, e-Investment filing, board interview — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/en/corporate/boi-application")({
  head: () => {
    const url = `${SEO_SITE}/en/corporate/boi-application`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/corporate/boi-application", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/corporate/boi-application", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/corporate/boi-application", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/corporate/boi-application", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/corporate/boi-application", "/en/corporate/boi-application")],
    };
  },
  component: () => <SubServicePage slug="corporate/boi-application" locale="en" />,
});
